import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import MainPage from './components/MainPage';
import HelpPage from './components/help/HelpPage';
import AnalysisPage from './components/Analysis/AnalysisPage';
import LPPage from './components/LP/LPPage';
import Terms from './components/LP/Terms';
import Privacy from './components/LP/Privacy';
import Legal from './components/LP/Legal';
import RegisterPage from './components/RegisterPage';
import CustomerSurvey from './components/Survey/CustomerSurvey';
import DraftEditor from './components/Survey/DraftEditor';
import AdminTestPage from './components/AdminTestPage';
import { supabaseClient } from './utils/supabaseClient';

function App() {
  const [session, setSession] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabaseClient.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabaseClient.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#007AFF]"></div>
      </div>
    );
  }

  return (
    <Router basename="/">
      <Routes>
        {/* LP（ランディングページ） */}
        <Route path="/" element={<LPPage />} />

        {/* ヘルプページ */}
        <Route path="/help" element={<HelpPage />} />

        {/* 利用規約ページ */}
        <Route path="/terms" element={<Terms />} />

        {/* プライバシーポリシーページ */}
        <Route path="/privacy" element={<Privacy />} />

        {/* 特定商取引法に基づく表記 */}
        <Route path="/legal" element={<Legal />} />

        {/* 分析ページ */}
        <Route path="/analysis" element={
          session ? (
            <AnalysisPage session={session} />
          ) : (
            <Navigate to="/app" replace />
          )
        } />

        {/* 管理ツール */}
        <Route
          path="/app/*"
          element={
            session ? (
              <MainPage session={session} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* ログインページ */}
        <Route
          path="/login"
          element={
            session ? (
              <Navigate to="/app" replace />
            ) : (
              <LoginPage />
            )
          }
        />

        {/* アカウント登録ページ */}
        <Route path="/register" element={<RegisterPage onBack={() => window.location.href = '/login'} />} />

        {/* アンケートページ（認証不要） */}
        <Route path="/survey/:shopName" element={<CustomerSurvey />} />

        {/* 下書き編集ページ（認証不要） */}
        <Route path="/draft/:sessionId" element={<DraftEditor />} />

        {/* 管理者専用テストページ（認証不要 - セキュリティは API 側で実装） */}
        <Route path="/admin/test-premium" element={<AdminTestPage />} />
      </Routes>
    </Router>
  );
}

export default App;